import { createSelector } from 'reselect'
import * as isNumber from 'lodash/isNumber'
import * as last from 'lodash/last'
import { State } from 'interfaces/state'
import { yourPeergroupIdSelector, selectedPeergroupIdSelector } from 'selectors/peergroupSelectors'
import { GenericTrendOwnProps } from 'interfaces/trend'
import { TimeframeTyped } from 'interfaces/global'
import { getMonthsCount, createTimeperiod } from 'helpers/dateTimeHelpers'
import { generateTrendLine } from 'helpers/trendHelpers'
import { createOwnPropsSelector } from 'selectors/globalSelectors'
import { isPIIVerifiedSelector } from 'selectors/creditSelectors'

const rawMemberGenericTrendSelector = (state: State, { type, timeframe }: GenericTrendOwnProps) =>
  state.data[type].trends[timeframe]

const zeroTrendGenerator = () => 0
export const memberGenericTrendSelector = createSelector(
  isPIIVerifiedSelector,
  rawMemberGenericTrendSelector,
  createOwnPropsSelector<GenericTrendOwnProps>(),
  (isPIIVerified, trend, { type, timeframe }) => {
    if (!isPIIVerified && type === 'creditscore') {
      const period = createTimeperiod(timeframe)
      return {
        actual: generateTrendLine(period, zeroTrendGenerator),
        average: 0,
      }
    }

    return trend
  }
)

export const hasMemberGenericTrendSelector = createSelector(
  memberGenericTrendSelector,
  Boolean,
)

// TODO: @pmyagkov use another criteria to split entities — data types (trend, breakdown)
// in this case we would have more desire to merge all the things
export const memberGenericRankCalculationValueSelector = createSelector(
  memberGenericTrendSelector,
  createOwnPropsSelector<GenericTrendOwnProps>(),
  (trend, { timeframe }) => {
    if (!trend) {
      return null
    }

    return getMonthsCount(timeframe) === 1
      ? last(trend.actual).amount
      : trend.average
  }
)

export const peergroupGenericTrendsSelector = (state: State, { type, timeframe }: GenericTrendOwnProps) =>
  state.data.peergroups[type].trends[timeframe]

export const hasPeergroupGenericTrendsSelector = createSelector(
  peergroupGenericTrendsSelector,
  yourPeergroupIdSelector,
  selectedPeergroupIdSelector,
  (trend, yourPeersId, selectedId) =>
    Boolean(trend) && [yourPeersId, selectedId].every((id) => isNumber(id) && Boolean(trend && trend.byKey[id]))
)

export const yourPeersGenericTrendsSelector = createSelector(
  peergroupGenericTrendsSelector,
  yourPeergroupIdSelector,
  (trends, peersId) =>
    isNumber(peersId) && trends && trends.byKey[peersId]
      ? trends.byKey[peersId]
      : null
)

export const othersGenericTrendsSelector = createSelector(
  peergroupGenericTrendsSelector,
  selectedPeergroupIdSelector,
  (trends, otherId) =>
    isNumber(otherId) && trends && trends.byKey[otherId]
      ? trends.byKey[otherId]
      : null
)


export const memberNetworthChangeSelector = (state: State, { timeframe }: TimeframeTyped) =>
  state.data.networth.change[timeframe]
